/*
 * Frontend feature flags supplied by Vite at build time.
 * Flags are opt-in: missing values and values other than "true" stay disabled.
 */

export const isAIInboxEnabled = import.meta.env.VITE_ENABLE_AI_INBOX === 'true';
